import { useContext } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import ExperienceOfferPageTicketSelection from '../ExperienceOfferPage/ExperienceOfferPageTicketSelection'
import Modal from 'LuxKit/Modal/Modal'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ExperienceOfferPageStateContext from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateContext'
import { useExperienceTicketsOptions } from 'hooks/ExperiencePage/useExperienceTicketsOptions'
import useExperienceAvailableTimes from 'hooks/ExperiencePage/useExperienceAvailableTimes'
import Caption from 'LuxKit/Typography/Caption'

interface Props {
  experienceView: App.ExperienceBookingView
}

function ExperienceBnblModal(props: Props) {
  const {
    experienceView,
  } = props

  const intl = useIntl()
  const pageState = useContext(ExperienceOfferPageStateContext)
  const { redemptionLocation, pickupPoint } = pageState
  const [slots] = useExperienceAvailableTimes(experienceView.originalExperience, {
    isBuyNowBookLater: true,
    redemptionLocationId: redemptionLocation?.id,
    pickupPointId: pickupPoint?.id,
  })
  const ticketOptions = useExperienceTicketsOptions(slots, { isBuyNowBookLater: true })

  const hasExpirationDates = !!(experienceView.originalExperience.bookByDate || experienceView.originalExperience.expirationDate)
  const showExpirationMessage = hasExpirationDates && !ticketOptions.some(ticket => ticket.bookByDate)

  const bookByDate = intlDateFormatter(
    experienceView.originalExperience?.bookByDate ?? experienceView.originalExperience?.expirationDate,
    INTL_DMY_CASUAL_FORMAT,
    intl.locale,
  )
  const expirationDate = intlDateFormatter(
    experienceView.originalExperience?.expirationDate,
    INTL_DMY_CASUAL_FORMAT,
    intl.locale,
  )

  const expirationMessage = intl.formatMessage(
    {
      id: '9w8fzJK1xM7LV9nFhLs6',
      defaultMessage: 'Please ensure you book by {bookByDate} for a date up to {expirationDate}.*',
    },
    { bookByDate, expirationDate },
  )

  return (
    <Modal
      title={intl.formatMessage({ id: 'V9l_UBS2ecyVSumt-sca', defaultMessage: 'Buy now, choose dates later' })}
      size="L"
    >
      <VerticalSpacer gap={16}>
        <VerticalSpacer gap={8}>
          <BodyText variant="large">
            {intl.formatMessage({
              id: 'stUcO8RgOXkBpSYX-Kj7',
              defaultMessage: 'This will secure the offer and give you the flexibility to choose your dates at a later time for all tickets.',
            })}
          </BodyText>
          {showExpirationMessage && <BodyText variant="large">{expirationMessage}</BodyText>}
          <Caption variant="medium">
            {intl.formatMessage({
              id: 'PibFt47usUo7jH8eX8Mo',
              defaultMessage: '*Subject to availability, and additional charges including seasonal, weekend, peak period, and property-specific surcharges.',
            })}
          </Caption>
        </VerticalSpacer>
        <ExperienceOfferPageTicketSelection
          experienceView={experienceView}
          isBuyNowBookLater
        />
      </VerticalSpacer>
    </Modal>
  )
}

export default ExperienceBnblModal
